<template>
    <div class="p-5 darker">
        <h5>
            Get instant reservations from your own website.
        </h5>

        <div class="my-4 border-color-6 p-2 radius-normal bg-red-pale" v-if="showStripeWarning">
            {{stripeWarningMessage}}
        </div>

        <div class="my-4">
            Reservations received trough this widget are automatically synced with Pluralo calendar.<br>
            Availabilities, prices, cancellation policy and other important information you enter in your company configurations will be shown to customers during reservation process.
        </div>

        <div class="d-flex align-items-end mb-4" v-if="!showNewWidgetCreator">
            <button class="btn wide" @click="toggleWidgetCreator">New Widget</button>
        </div>

        <!-- Widget creator -->
        <div v-if="showNewWidgetCreator" class="mb-5">
            <h2 class="mb-2">Create New</h2>
            <div>
                <widget-editor :isCreatingWidget="true" v-bind:widget.sync="newWidget" :productOptions="productsArray" :validation="$v.newWidget" @refreshWidgetList="downloadAllWidgets" @creatingCancel="creatingCancel" @creatingSave="createWidgetButtonOptions"></widget-editor>
            </div>
        </div>

        <div class="col-sm-12 text-center" v-if="loadingWidgets">
            <loader></loader>
        </div>

        <div class="" v-if="!loadingWidgets">
            <div class="row">
                <div class="col-sm-12">
                    <h2 v-if="widgetsArray.length >0" class="mb-2">Current Widgets</h2>
                    <widget-editor v-bind:widget.sync="widget" :productOptions="productsArray" v-for="widget in sortedWidgets" :key="widget.id" @refreshWidgetList="downloadAllWidgets"></widget-editor>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import extendedVSelect from '@/extends/vue-select'
    import { mapGetters, mapActions } from 'vuex'
    import Loader from '@/tools/loaders/loader1'
    import WidgetEditor from '@/tools/widget/widgetEditor'
    import WidgetComposer from '@/tools/widget/widgetComposer'
    import { required, email, minLength } from 'vuelidate/lib/validators'

    export default {
        created() {
            this.downloadAllWidgets()
            this.getProducts()
            this.setVirginWidget()
        },
        data() {
            return {
                stripeIntegrationInfo: null,
                showNewWidgetCreator: false,
                loadingWidgets: false,
                productsArray: null,
                treatedProducts: null,
                futureWidgetName: null,
                widgetsArray: [],
                selectedProduct: {
                    name:'All Products',
                    allProducts: true
                },
                allProducts: {
                    name:'All Products',
                    allProducts: true
                },
                newWidget: null
            }
        },
        validations: {
            newWidget: {
                products: {
                    function () {
                        return true;
                    }
                },
                name: {
                    required
                }
            }
        },
        computed: {
            ...mapGetters([
                'account',
                'getWidgets',
                'getCleanDefaultWidget',
                'getCompanySettings',
                'getIsLoadingSupplierIntegrations',
                'getSingleIntegration',
                'getAllIntegrations',
            ]),
            stripeIntegration() {
                if (this.getAllIntegrations.length > 0 && this.getIsLoadingSupplierIntegrations == false) {
                    return this.getSingleIntegration(101);
                } else {
                    return false;
                }
            },
            showStripeWarning() {
                if (this.stripeIntegration) {
                    return this.stripeIntegration.integrationStatusInfo > 0 || this.stripeIntegration.integrationStatus == 0;
                } else {
                    return false;
                }
            },
            stripeWarningMessage() {
                let errorMessage = '';

                if (this.showStripeWarning && this.stripeIntegration.integrationStatusInfoMessage == 'Test Keys') {
                    errorMessage += 'Warning: You are using a Test Stripe Account, make sure to use Live Keys when you are ready to sell your products via Widget';
                } else if (this.stripeIntegration.integrationStatus == 0) {
                    errorMessage += 'Your Stripe account is missing, check your Stripe integration at "Company Settings -> Integrations"';
                } else {
                    return false;
                }

                return errorMessage;
            },
            sortedWidgets() {
                return this.widgetsArray.sort((a, b) => b.id - a.id);
            },
        },
        methods:{
            ...mapActions([
                'getAllWidgets',
                'createWidget',
                'createWidgetOptions',
                'deleteWidget',
                'updateWidget',
                'downloadVirginWidget',
            ]),
            setVirginWidget() {
                this.newWidget = JSON.parse(JSON.stringify(this.getCleanDefaultWidget));
            },
            creatingCancel() {
                this.showNewWidgetCreator = false;
            },
            toggleWidgetCreator: function () {
                this.downloadVirginWidget().then(virginWidget => {
                    let baseWidget = JSON.parse(JSON.stringify(this.getCleanDefaultWidget));
                    this.newWidget = baseWidget;
                    this.$set(this.newWidget, 'categoryProductList', virginWidget.categoryProductList);
                    this.showNewWidgetCreator = !this.showNewWidgetCreator;
                });
            },
            getProducts() {
                axios.get('/api/booking/Resume', {
                    params: {
                        supplierId: this.account.supplierId
                    }
                }).then(response => {
                    if (response && response.status === 200 && response.data) {
                        this.productsArray = response.data.productList;

                        // Options for the dropdown
                        this.treatedProducts = JSON.parse(JSON.stringify(response.data.productList));
                        this.treatedProducts.unshift(this.allProducts);

                        return response.data;
                    }
                }).catch (error => {
                    this.$toasted.error(error.response.data.message);
                })
            },
            generateIframeCode(guid) {
                return '<iframe src="'+process.env.WIDGET_URL+'/?guid='+guid+'" width="400" height="600" style="position: relative;display: block;margin: auto;border: none;width: 100%;max-width: 400px;height: 600px;max-height:100%;" allow="payment"></iframe>';
            },
            generateWidgetName(widget) {
                if (widget.products.length == 0) {
                    return 'All products';
                } else {
                    return widget.products[0].name;
                }
            },
            downloadAllWidgets() {
                this.loadingWidgets = true;
                this.getAllWidgets().then(response => {
                    this.loadingWidgets = false;
                    if (response && response.status === 200) {
                        this.widgetsArray = response.data;
                    }
                })
            },
            createWidgetButton() {
                let productsForWidget = [this.selectedProduct];

                // If "All products is selected"
                if (productsForWidget[0].allProducts) {
                    productsForWidget = [];
                }

                this.createWidget({
                    name: this.futureWidgetName,
                    products: productsForWidget
                }).then(response => {
                    if (response && response.status === 200) {
                        this.futureWidgetName = null;
                        this.$toasted.success('Widget generated');
                        this.downloadAllWidgets();
                    }
                })
            },
            createWidgetButtonOptions() {
                this.showNewWidgetCreator = false
                this.createWidgetOptions(this.newWidget).then(response => {
                    if(response && response.status == 200){
                        this.futureWidgetName = null;
                        this.$toasted.success('Widget generated');
                        this.downloadAllWidgets();
                    }
                })
            },
            widgetCreatorChanged() {
                this.$v.newWidget.$touch;
            },
            deletThisWidget(widget) {
                let vm = this;
                
                this.$dialog.confirm('<b>Delete Widget?</b><br>This action is irreversible!')
                .then(() => {
                    vm.deleteWidget(widget).then(response => {
                        vm.$toasted.success(response.data);
                        vm.removeWidgetfromArray(widget)
                    })
                })
                .catch(() => {});
            },
            copyWidget(widget) {
                let widgetIframe = this.generateIframeCode(widget.guid);
                this.$clipboard(widgetIframe);
                this.$toasted.success('Widget code copied');
            },
            activateEditionMode(widget) {
                widget.originalProducts = widget.products;

                if (widget.products.length == 0 || widget.products[0].allProducts) {
                    widget.helperSelectedProduct = this.allProducts;
                } else {
                    widget.helperSelectedProduct = widget.products[0];
                }

                if (!widget.editing) {
                    this.$set(widget, 'editing', true);
                }
            },
            editWidgetProductChanged(widget) {
                let productsForWidget = [widget.helperSelectedProduct];

                // If "All products is selected"
                if (productsForWidget[0].allProducts) {
                    productsForWidget = [];
                }

                widget.products = productsForWidget;
            },
            saveEditedWidget(widget) {
                if (!widget.loading) {
                    this.$set(widget, 'loading', true);
                    this.updateWidget(widget).then(response => {
                        widget.loading = false;
                        widget.editing = false;
                    })
                }
            },
            cancelEditedWidget(widget) {
                widget.products = widget.originalProducts;
                widget.editing = false;
            },
            removeWidgetfromArray(widgetToRemove) {
                this.widgetsArray.splice(this.widgetsArray.indexOf(widgetToRemove), 1);
            },
        },
        components:{
            vSelect: extendedVSelect,
            Loader,
            WidgetEditor,
            WidgetComposer
        }
    }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// TabWidget.vue?7e48d239